import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import RoutesList from "./routes";

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <div className="font-inter flex flex-col">
        <RoutesList />
      </div>
    </QueryClientProvider>
  );
}

export default App;
